import React from 'react'
import {useParams} from 'react-router-dom'
import {BASE_URL} from '../../config'
import {useQuery} from 'react-query'
import axios from 'axios'
import {Helmet} from 'react-helmet-async'
import {Content} from '../../../../_metronic/layout/components/content'
import {BlobProvider} from '@react-pdf/renderer'
import VoucherPreviewContent from './VoucherPreviewContent'
import {IVoucherDetailsResponse} from './_model'
import {useUserStateProvider} from '../../../utils/contextProvider/UserStateProvider'

const GET_VOUCHER_BY_ID = `${BASE_URL}/api/protect/getVouchereById`

const VoucherPreview = () => {
  const {userAttachments} = useUserStateProvider()
  const {id} = useParams()

  const {data, isLoading} = useQuery<IVoucherDetailsResponse>({
    queryKey: ['voucherPreview'],
    queryFn: async () => {
      const response = await axios.get(GET_VOUCHER_BY_ID, {params: {vouchereId: id}})
      const data = await response.data
      return data
    },
    enabled: !!id,
  })

  let contentHelmet = (
    <Helmet>
      <title>Voucher Preview</title>
    </Helmet>
  )

  if (isLoading) {
    return (
      <Content>
        {contentHelmet}
        <div className='d-flex justify-content-center align-items-center'>
          <div className='spinner-border' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </div>
        </div>
      </Content>
    )
  }

  return (
    <div
      style={{
        height: '100vh',
        width: '900px',
        display: 'flex',
        flexDirection: 'column',
        margin: '10px auto',
      }}
    >
      {/* ===== LIVE PDF PREVIEW ===== */}
      <div style={{flex: 1}}>
        <div style={{width: '900px', height: '100vh', background: 'white'}}>
          <BlobProvider
            document={
              <VoucherPreviewContent voucherResponse={data} logo={userAttachments.userprofile} />
            }
          >
            {({url, loading}) =>
              loading ? (
                <p className='text-center fw-semibold fs-4 mt-5'>Loading PDF...</p>
              ) : (
                <iframe
                  src={url!}
                  style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    background: 'white',
                    overflow: 'hidden',
                  }}
                />
              )
            }
          </BlobProvider>
        </div>
      </div>
    </div>
  )
}

export default VoucherPreview
